module.exports = __webpack_public_path__ + "img/d4c76c7.jpg";